module.exports = __webpack_public_path__ + "img/level.c90ceee7.svg";